module.exports = __webpack_public_path__ + "assets/img/visa@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/visa@2x.png
// module id = 144
// module chunks = 0